import React from 'react';
import '../css/dataTables.css';

const renderTable = (props) => {
    const {
        id,
        headers,
        data,
        disabled,
        allData,
        action,
        tableProps: {
            actPos,
            selection,
            idSelection,
        },
        selectionProps: {
            selectedAll,
            selectionList,
            selectAllAction,
            selectOneAction,
        },
        paginatedProps: {
            paginated = true,
            enableShowMore = false,
            showMoreAction,
            enableShowLess = false,
            showLessAction,
        },
    } = props;
    let header = "";
    let body = "";

    const columns = headers.filter(({value}) => value) || [];

    if (columns.length > 0) {
        header = 
            <tr key={"headers"}>
                {actPos === 'start' ?
                <>
                    <td className="table-header-yellow text-center" key={"headers-action"}>
                        {selection === "multiple" &&
                            <input
                                id="chSelectAll"
                                type="checkbox"
                                disabled={disabled}
                                checked={selectedAll}
                                onChange={() => selectAllAction(allData)} />
                        }
                    </td>
                    {columns.map(column => <td className="table-header-yellow" key={`header-${column.title}`}>{column.title || ''}</td>)}
                </>
                :
                <>
                    {columns.map(column => <td className="table-header-yellow" key={`header-${column.title}`}>{column.title || ''}</td>)}
                    <td className="table-header-yellow text-center" key={"headers-action"}>
                        {selection === "multiple" &&
                            <input
                                id="chSelectAll"
                                type="checkbox"
                                disabled={disabled}
                                checked={selectedAll}
                                onChange={selectAllAction} />
                        }
                    </td>
                </>
                }
                
            </tr>;
    }

    body = (<>
        {data.map((register, index) => {
            return (
                <tr key={index}>
                    {actPos === 'start' ?
                    <>
                        <td style={{textAlign:"center"}} className={index % 2 === 0 ? 'dt-row-primary' : 'dt-row-secondary'} key={`col-action-${index}`}>
                            {selection === "multiple" ?
                                    <input
                                        id={`chSelect-${index}`}
                                        type="checkbox"
                                        disabled={disabled}
                                        checked={!!selectionList.find(element => element === register[idSelection])}
                                        onChange={() => selectOneAction(register[idSelection], allData)} />
                                :
                                <button
                                    className="btn btn-sm"
                                    disabled={disabled}
                                    onClick={() => action(register)}
                                    style={{fontWeight: '500', backgroundColor: "transparent", color: "#EABF28"}}>
                                    <i className="fas fa-check"></i>  
                                </button>
                            }
                        </td>
                        {columns.map(column => <td className={`${column.classes || ''} ${index % 2 === 0 ? 'dt-row-primary-light' : 'dt-row-secondary-light'}`} key={`col-${column.title}-${index}`}>{column.format ? column.format(register[column.field] || '') : register[column.field] || ''}</td>)}
                    </>
                    :
                    <>
                        {columns.map(column => <td className={`${column.classes || ''} ${index % 2 === 0 ? 'dt-row-primary' : 'dt-row-secondary'}`} key={`col-${column.title}-${index}`}>{column.format ? column.format(register[column.field] || '') : register[column.field] || ''}</td>)}
                        <td style={{textAlign:"center"}} className={index % 2 === 0 ? 'dt-row-primary-light' : 'dt-row-secondary-light'} key={`col-action-${index}`}>
                            {selection === "multiple" ?
                                    <input
                                        id={`chSelect-${index}`}
                                        type="checkbox"
                                        disabled={disabled}
                                        checked={!!selectionList.find(element => element === register[idSelection])}
                                        onChange={() => selectOneAction(register[idSelection], allData)} />
                                :
                                <button
                                    className="btn btn-sm"
                                    disabled={disabled}
                                    onClick={() => action(register)}
                                    style={{fontWeight: '500', backgroundColor: "transparent", color: "#EABF28"}}>
                                    <i className="fas fa-check"></i>  
                                </button>
                            }
                        </td>
                    </>
                    }
                </tr>
            )
        })}

        {!paginated && (enableShowMore || enableShowLess) &&
            <tr key="row-noPaginated">
                <td key="col-noPAginated" className="container dt-row-primary" colSpan={columns.length + 1}>
                    <div className="row">
                        {enableShowMore && <div className="col-3"> <button className="border-0" onClick={showMoreAction}><i className="fa fa-chevron-down" /> Mostrar más </button> </div>}
                        {enableShowLess && <div className="col-3"> <button className="border-0" onClick={showLessAction}><i className="fa fa-chevron-up" /> Mostrar menos </button> </div>}
                    </div>
                </td>
            </tr>
        }
    </>);

    if (!Array.isArray(data) || data.length === 0) {
        body = (
            <tr key="0">
                <td className="dt-row-primary" style={{textAlign:"center"}} colSpan={columns.length + 1 || 1} key={"0-0"}>
                    No hay información para mostrar
                </td>
            </tr>
        );
    }

    let table = "";

    table = 
    <div className="table-wrapper-scroll-y my-custom-scrollbar">
        <table id={id} className="display" style={{width: '100%',overflow:'auto'}}>
            <thead className="table-header ">
            {header}
            </thead>
            <tbody>
            {body}
            </tbody>
        </table>
    </div>;

    return table;
};

export const renderStandardTableCreate = (props) => { return renderTable(props); }